import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SkeletonCard from '../../../components/Redesing/skeleton/SkeletonCard';
import SkeletonTable from '../../../components/Redesing/skeleton/SkeletonTable';

/**
 * Skeleton component for the user details page
 * Displays while user data is loading
 */
function UserDetailsSkeleton() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Stack spacing={3}>
        {/* Header skeleton */}
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Stack direction="row" spacing={2} alignItems="center">
            {/* Back button */}
            <Skeleton variant="circular" width={40} height={40} />
            {/* Icon */}
            <Skeleton variant="circular" width={48} height={48} />
            <Stack spacing={0.5}>
              {/* User name */}
              <Skeleton variant="text" width={200} height={32} />
              {/* User ID chip */}
              <Stack direction="row" spacing={1} alignItems="center">
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton variant="rectangular" width={120} height={24} sx={{ borderRadius: 1 }} />
              </Stack>
            </Stack>
          </Stack>
          {/* Action buttons */}
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={70} height={36} sx={{ borderRadius: 1 }} />
          </Stack>
        </Stack>

        {/* Tabs skeleton */}
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={110} height={36} sx={{ borderRadius: 1 }} />
        </Stack>

        {/* Content skeleton - two column layout */}
        <Grid container spacing={2}>
          {/* Left column */}
          <Grid xs={12} md={5}>
            <Stack spacing={2}>
              {/* Basic Details card */}
              <SkeletonCard title rows={5} />
              {/* Payment Information card */}
              <SkeletonCard title rows={5} />
            </Stack>
          </Grid>

          {/* Right column */}
          <Grid xs={12} md={7}>
            <Stack spacing={2}>
              {/* User Memberships */}
              <SkeletonTable rows={2} />
              {/* Reported Problems */}
              <SkeletonTable rows={2} />
              {/* User RFID Cards */}
              <SkeletonTable rows={2} />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}

export default UserDetailsSkeleton;
